import request from 'utils/request'
import {MCBPS010InitRequest} from 'types/MCBPS010/MCBPS010InitRequest'
import {MCBPS010CreateRequest} from 'types/MCBPS010/MCBPS010CreateRequest'

export const initApi = (param: MCBPS010InitRequest) =>
  request({
    url: `/MCBPS010/init`,
    method: 'post',
    data: param
  })

export const createApi = (param: MCBPS010CreateRequest) => {
  const formData = new FormData();
  formData.append("uploadFiletmp", param.uploadFile);
  formData.append("jsonData", encodeURIComponent(JSON.stringify(param)));
  return request({
    url: `/MCBPS010/create`,
    method: 'post',
    data: formData,
  })
}